import React from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter as Router, } from "react-router-dom";
import { Provider } from 'react-redux';

import './scss/index.scss';
import 'react-datalist-input/dist/styles.css';
//import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const app_title = process.env.REACT_APP_TITLE ?? 'Influenzanet Admin';

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App app_title={app_title} />
      </Router>
    </Provider>
  </React.StrictMode>
);

// @ts-ignore
document['_store'] = store; 

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
